var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBackIcon = function SvgBackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "second-button-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.981,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "back-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108688",
    d: "M222.14 263h21.981v20H222.14Z",
    fill: "#eff0f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "noun-back-1829444",
    transform: "translate(-222.14 -263)",
    clipPath: "url(#back-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108687",
    d: "M242.685 271.593h-15.744l6.168-6.167a1.418 1.418 0 0 0-2.006-2.006l-8.55 8.548a1.414 1.414 0 0 0-.409 1.021v.022c0 .01.007.022.007.033a1.1 1.1 0 0 0 .28.776 1.428 1.428 0 0 0 .125.19l8.55 8.548a1.418 1.418 0 0 0 2.006-2.006l-6.125-6.125h15.7a1.419 1.419 0 1 0 0-2.837",
    fillRule: "evenodd"
  }))));
};
export default SvgBackIcon;